import { initContract } from '@ts-rest/core'
import z from 'zod'
import { Brand, ErrorResponseSchema } from '../../shared'
import {
  LykaGeneratedPlanSchema,
  LykaGeneratePlanOutputSchema,
  LykaGeneratePlansBodyInputSchema,
  LykaGeneratePlansBodySchema,
  GetRecommendedServingSizeBodySchema,
  RecommendedServingSizeSchema,
  LykaGeneratePuppyServingSizesBodySchema,
  LykaGeneratePuppyServingSizesResponseSchema,
  LykaServingSizeSchema,
  PlanSchema,
  TygaGeneratedPlanSchema,
  TygaGeneratePlansBodySchema,
  UUIDOrSlugSchema,
} from './plan.schemas'

const c = initContract()

const options = {
  pathPrefix: '/plans',
  commonResponses: {
    400: ErrorResponseSchema,
    500: ErrorResponseSchema,
    404: ErrorResponseSchema,
    422: ErrorResponseSchema,
    503: ErrorResponseSchema,
  },
}

export const planServiceContract = c.router({
  getPlans: {
    method: 'GET',
    path: '',
    query: z.object({
      brand: z.nativeEnum(Brand).default(Brand.LYKA),
    }),
    responses: {
      200: PlanSchema.array(),
    },
  },
  lykaGetServingSizes: {
    method: 'GET',
    path: '/lyka/serving-sizes',
    responses: {
      200: LykaServingSizeSchema.array(),
    },
  },
  /* deprecated in favor of lykaGeneratePlans */
  generatePlans: {
    method: 'POST',
    path: '/generate',
    deprecated: true,
    description: 'Deprecated in favor of /lyka/generate',
    body: LykaGeneratePlansBodySchema,
    responses: {
      200: LykaGeneratedPlanSchema.array(),
    },
  },
  lykaGeneratePlans: {
    method: 'POST',
    path: '/lyka/generate',
    body: LykaGeneratePlansBodyInputSchema,
    responses: {
      200: LykaGeneratePlanOutputSchema.array(),
    },
  },
  getRecommendedServingSize: {
    method: 'POST',
    path: '/lyka/recommended-serving-size',
    body: GetRecommendedServingSizeBodySchema,
    responses: {
      200: RecommendedServingSizeSchema,
    },
  },
  lykaGeneratePuppyServingSizes: {
    method: 'POST',
    path: '/lyka/puppy-serving-sizes/generate',
    body: LykaGeneratePuppyServingSizesBodySchema,
    responses: {
      200: LykaGeneratePuppyServingSizesResponseSchema,
    },
  },
  tygaGeneratePlans: {
    method: 'POST',
    path: '/tyga/generate',
    body: TygaGeneratePlansBodySchema,
    responses: {
      200: TygaGeneratedPlanSchema.array(),
    },
  },
  getPlan: {
    method: 'GET',
    path: '/:id',
    pathParams: z.object({
      id: UUIDOrSlugSchema,
    }),
    responses: {
      200: PlanSchema,
    },
  },
}, options)
